import React, { useState } from "react";
import styled from "styled-components";
import { FaArrowRight } from "react-icons/fa";
import { ImCross } from "react-icons/im";

const BottomBanner = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <Container>
      <Title>HIPAA Notice of Privacy</Title>
      <SubTitle>
        Learn about HIPAA's Notice of Privacy and how it protects you.
      </SubTitle>
      <Btn onClick={toggleModal}>
        Learn More <FaArrowRight />
      </Btn>
      {modal && (
        <PopUpContainer onClick={toggleModal}>
          <PopUp>
            <PopUpInner>
              <PopUpHeader>
                HIPAA Notice of Privacy <ImCross onClick={toggleModal} />{" "}
              </PopUpHeader>
              <PopUpBody>
                NOTICE OF PRIVACY PRACTICES Effective April 14, 2003 THIS NOTICE
                DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND
                DISCLOSED AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE
                REVIEW IT CAREFULLY. As part of the federal Health Insurance
                Portability and Accountability Act of 1996, known as HIPAA, the
                pharmacy has created this Notice of Privacy Practices (Notice).
                This Notice describes the pharmacy's private practices and the
                rights you, the individual, have as they relate to the privacy
                of your Protected Health Information (PHI). Your PHI is
                information about you, or that could be used to identify you, as
                it relates to your past and present physical and mental health
                care services. The HIPAA regulations require that the pharmacy
                protect the privacy of your PHI that the pharmacy has received
                or created. This pharmacy will abide by the terms presented
                within this Notice. For any uses or disclosures that are not
                listed below, the pharmacy will obtain a written authorization
                from you for that use or disclosure, which you will have the
                right to revoke at any time, as explained in more detail below.
                The pharmacy reserves the right to change the pharmacy's privacy
                practices and this Notice. Revisions to the Notice will be
                posted in the pharmacy and upon your request, provided to you in
                a paper format. HOW THE PHARMACY MAY USE AND DISCLOSE YOUR PHI
                The following is an accounting of the ways that the pharmacy is
                permitted, by law, to use and disclose your PHI. Uses and
                disclosures of PHI for Treatment: We will use the PHI that we
                receive from you to fill your prescription and coordinate or
                manage your health care. Uses and disclosures of PHI for
                Payment: The pharmacy will disclose your PHI to obtain payment
                or reimbursement form insurers for your health care services.
                Uses and disclosures of PHI for Health Care Operations: The
                pharmacy will use your PHI to conduct quality assessments,
                improvement activities, and evaluate the pharmacy workforce. The
                following is an accounting of additional ways in which the
                pharmacy is permitted or required to use or disclose phi about
                you without your written authorization: Uses and disclosures as
                required by law: The pharmacy is required to use and disclose
                PHI about you as required and as limited by law. Uses and
                disclosures for public health activities: The pharmacy may use
                or disclose PHI about you to a public health authority that is
                authorized by law to collect for the purpose of preventing,
                controlling disease, injury, or disability. Uses and disclosure
                about victims of abuse, neglect or domestic violence: The
                pharmacy may use or disclose PHI about you to a government
                authority if it is reasonably believed you are a victim of
                abuse, neglect or domestic violence. Uses and disclosures for
                health oversight activities: The pharmacy may use or disclose
                PHI about you to a health oversight agency for oversight
                activities that it is authorized by law to conduct. Disclosures
                for judicial and administrative proceedings: The pharmacy may
                disclose PHI about you in the course of any judicial or
                administrative proceedings, provided that proper documentation
                is presented to the pharmacy. Disclosures for law enforcement
                purposes: The pharmacy may disclose PHI about you to law
                enforcement officials for authorized purposes. Uses and
                disclosures about the deceased: The pharmacy may disclose PHI
                about a deceased, or prior to, and in reasonable anticipation of
                an individual's death, to coroners, medical examiners, and
                funeral directors. Uses and disclosures for cadaveric organ, eye
                or tissue donation purposes: The pharmacy may use and disclose
                PHI for the purpose of procurement, banking, or transplantation
                of cadaveric organs, eyes, or tissues for donation purposes.
                Uses and disclosures for research purposes: The pharmacy may use
                and disclose PHI about you for research purposes with valid
                waiver of authorization approved by an institutional review
                board or a privacy board. Otherwise, the pharmacy will request a
                signed authorization by the individual for all other research
                purposes. Uses and disclosures to avert a serious threat to
                health or safety: The pharmacy may use or disclose PHI about
                you, if it believed in good faith, and is consistent with any
                applicable law and standards of ethical conduct, to avert a
                serious threat to health or safety. Uses and disclosures for
                specialized government functions: The pharmacy may use or
                disclose PHI about you for specialized government functions
                including; military and veteran's activities, national security
                and intelligence, protective services, department of state
                functions, and correctional institutions and law enforcement
                custodial situations. Disclosure for workers' compensation: The
                pharmacy may disclose PHI about you as authorized by and to the
                extent necessary to comply with workers' compensation laws or
                programs established by law. Disclosures for disaster relief
                purposes: The pharmacy may disclose PHI about you as authorized
                by law to a public or private entity to assist in disaster
                relief efforts. Disclosures to business associates: The pharmacy
                may disclose PHI about you to the pharmacy's business associates
                for services that they may provide to or for the pharmacy. OTHER
                USES AND DISCLOSURES The pharmacy may contact you for the
                following purposes: Refill reminders: The pharmacy may contact
                you to remind you of your prescription upon such time they are
                ready to be refilled. Information about treatment alternatives:
                The pharmacy may contact you to notify you of alternative
                treatments and/or products. Health related benefits or services:
                The pharmacy may use your PHI to notify you of benefits and
                services the pharmacy provides. Fundraising: If the pharmacy
                participates in a fundraising activity, the pharmacy may use
                demographic PHI to send you a fundraising packet, or the
                pharmacy may disclose demographic PHI about you to its business
                associate or an institutionally related foundation to send you a
                fundraising packet. No further disclosure will be allowed by the
                business associates or an institutionally related foundation
                without your written authorization. FOR ALL OTHER USES AND
                DISCLOSURES The pharmacy will obtain a written authorization
                from you for all other uses and disclosures of PHI, and the
                pharmacy will only use or disclose pursuant to such an
                authorization. In addition, you may revoke such an authorization
                in writing at any time. To revoke a previously authorized use or
                disclosure, please contact the pharmacy. YOUR HEALTH INFORMATION
                RIGHTS The following are a list of your rights in respect to
                your PHI. Request restrictions on certain uses and disclosures
                of your PHI: You have the right to request additional
                restrictions of the pharmacy?s uses and disclosures of your PHI;
                however, the pharmacy is not required to accommodate a request.
                If you wish to request additional restrictions, please obtain
                the form, Request for Restriction of Uses & Disclosures, from
                the pharmacy and return the completed form to the pharmacy. The
                right to have your PHI communicated to you by alternate means or
                locations: You have the right to request that the pharmacy
                communicate confidentially with you using an address or phone
                number other than your residence. However, state and federal
                laws require the pharmacy to have an accurate address and home
                phone number in case of emergencies. The pharmacy will consider
                all reasonable requests. If you wish to request a change in your
                communicating address and/or phone number, please obtain a form,
                Request for Alternative Arrangements for Confidential
                Communication, from the pharmacy and return the completed form
                to the pharmacy. The right to inspect and/or obtain a copy of
                your PHI: You have the right to request access and/or obtain a
                copy of your PHI that is contained in the pharmacy for the
                duration the pharmacy maintains PHI about you. If you wish to
                inspect or obtain a copy of your PHI, please obtain a form,
                Request for Access to Records, from the pharmacy and return the
                completed form to the pharmacy. There may be a reasonable
                cost-based charge for photocopying documents. You will be
                notified in advance of incurring such charges, if any. The right
                to amend your PHI: You have the right to request an amendment of
                the PHI the pharmacy maintains about you, if you feel that the
                PHI the pharmacy has maintained about you is incorrect or
                otherwise incomplete. Under certain circumstances we may deny
                your request. If we do deny the request, you will have the right
                to have the denial reviewed by someone we designate who was not
                involve in the initial review. You may ask to Secretary, United
                States Department of Health and Human Services, or their
                appropriate designee, to review such a denial. If you wish to
                amend your PHI files, please obtain a form, Request for
                Amendment of PHI, from the pharmacy and return the completed
                form to the pharmacy. The right to receive and accounting of
                disclosures of your PHI: You have the right to receive an
                accounting of certain disclosures of your PHI made by the
                pharmacy. If you wish to receive an accounting of disclosures of
                your PHI, please obtain form, Request for Accounting of
                Disclosures, from the pharmacy and return the completed form to
                the pharmacy. You should be aware; however, that such an
                accounting excludes uses and disclosures made for treatment,
                payment and health care operations purposes. The right to
                receive additional copies of the Pharmacy?s Notice of Privacy
                Practices: you have the right to receive additional paper copies
                of this Notice, upon request, even if you initially agreed to
                receive the Notice electronically. If you with to receive a
                paper copy of this notice, please ask a pharmacy workforce
                member and they will provide you with a copy. REVISIONS TO THE
                NOTICE OF PRIVACY PRACTICES The pharmacy reserves the right to
                change and/or revise this Notice and make the new revised
                version applicable to all PHI received prior to its effective
                date. The revised Notice will be available, upon request, to all
                individuals. The pharmacy will also post the revised version of
                the Notice in the pharmacy. COMPLAINTS If you believe your
                privacy rights have been violated, you may file a complaint with
                the pharmacy and/or to the Secretary of HHS, or his designee. If
                you wish to file a complaint with the pharmacy, please contact
                the Privacy Officer. If you wish to file a complaint with the
                Secretary, please write to: The U.S. Department of Health and
                Human Services Office of the Inspector General 200 Independence
                Ave, S.W. Washington, D.C. 20201 The pharmacy will not take any
                adverse action against you as a result of your filing of a
                complaint. CONTACT INFORMATION If you have any questions on the
                pharmacy's privacy practices or for clarification on anything
                contained within the Notice, please contact:
                <br />
                <br />
                Lincourt Pharmacy <br />
                501 S Lincoln Ave. Clearwater, FL 33756
                <br />
                Phone: (727) 447-4248
              </PopUpBody>
            </PopUpInner>
          </PopUp>
        </PopUpContainer>
      )}
    </Container>
  );
};

export default BottomBanner;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: var(--color-blue);
  padding: 5rem 3rem 5rem 3rem;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
  font-size: 3rem;
  font-weight: 600;
  color: white;
  letter-spacing: 3px;
  text-align: center;

  @media screen and (max-width: 1220px) {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
  }
`;

const SubTitle = styled.h5`
  font-size: 2.2rem;
  letter-spacing: 1.5px;
  color: white;
  text-align: center;

  @media screen and (max-width: 1220px) {
    font-size: 1.8rem;
  }
`;

const Btn = styled.button`
  margin-top: 1rem;
  padding: 1rem;
  font-size: 1.5rem;
  letter-spacing: 1.5px;
  background: white;
  color: var(--color-blue);
  border: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  cursor: pointer;

  &:hover {
    outline: 2px solid black;
  }

  @media screen and (max-width: 1220px) {
    font-size: 1rem;
  }
`;

const PopUpContainer = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
`;

const PopUp = styled.div`
  background: rgba(49, 49, 49, 0.8);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0%;
`;

const PopUpInner = styled.div`
  background-color: white;
  height: 85%;
  width: 65%;
  position: fixed;
  top: 10%;
  right: 18%;
  padding: 3rem;
`;

const PopUpHeader = styled.div`
  color: var(--color-blue);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 2rem;
  font-weight: 900;
  letter-spacing: 2px;
  margin-bottom: 1.5rem;
`;

const PopUpBody = styled.div`
  padding: 1.5rem;
  font-size: 1.2rem;
  overflow: scroll;
  height: 85%;
  width: 100%;
  border: 2px solid black;
  opacity: 0.4;
`;
